import { Component, OnInit } from '@angular/core';
import { PolicyMessages } from '../../modules/shared/models/component-messages/policy-messages';
import { TranslateService } from '@ngx-translate/core';
import { NavigationStart, Router } from '@angular/router';
import { ToastMessages } from '../../modules/shared/models/component-messages/toast-messages';

declare var require: any;
const FileSaver = require('file-saver');

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss']
})
export class PolicyComponent implements OnInit {

  public policyMessages = new PolicyMessages();
  public toastMessages: ToastMessages = new ToastMessages();
  public errorPlan = false;
  public moduleName: string;
  private policySignatureFileName = 'Politique_Signature_v1_2.pdf';

  constructor(
    public router: Router,
    public translate: TranslateService) {
  }

  public ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (event.url.toString().trim() === '/verifier/process') {
          this.moduleName = this.policyMessages.verifySignature;
        } else if (event.url.toString().trim() === '/signer') {
          this.moduleName = this.policyMessages.createSignature;
        }
      }
    });
  }

  public getPolicy() {
    this.downloadPdf();
  }

  public isEnterPressed() {
    // Get the input field
    const input = document.getElementById('notre-politique');

    // Execute a function when the user releases a key on the keyboard
    input.addEventListener('keyup', (event) => {
      // Number 13 is the "Enter" key on the keyboard
      if (event.keyCode === 13) {
        // Cancel the default action, if needed
        event.preventDefault();
        // Trigger the button element with a click
        document.getElementById('getpolicybutton').click();
      }
    });
  }

  private downloadPdf() {
    const pdfUrl = './assets/pdf/AIFE_Politique_Signature_v1_2.pdf';
    FileSaver.saveAs(pdfUrl, this.policySignatureFileName);
  }

  public isVerificationArea(): boolean {
    return this.router.url.includes('/verifier/process');
  }

}
